const UC_SERVICE_ID = 'S1pcEj_jZX';

const ConsentGate = ({ consentNote, children }) => {
  const uc = window.uc;
  const consentGiven = uc && uc.getStatus(UC_SERVICE_ID);

  if (consentGiven) {
    return children;
  }

  const handleAccept = e => {
    e.preventDefault();
    if (window.UC_UI) {
      window.UC_UI.acceptService(UC_SERVICE_ID);
    }
  };

  return (
    <div className="uberall-locations__consent textmedia">

      <div className="textmedia__wrapper">
        <div className="textmedia__text is-animated active" data-animated="">

          {consentNote && <p className="uberall-locations__consent-note">{consentNote}</p>}

          <button className="btn btn--primary" onClick={handleAccept}>
            Karte anzeigen
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentGate;

